import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Subscription } from '../Profile/types'

export interface IPortalState {
  isUnitsModalOpen: boolean
  confirmCancel: Subscription | undefined
}

const initialState: IPortalState = {
  isUnitsModalOpen: false,
  confirmCancel: undefined,
}

export const slice = createSlice({
  name: 'portal',
  initialState,
  reducers: {
    onOpenUnitsModal: (
      state: IPortalState,
      action: PayloadAction<typeof initialState.isUnitsModalOpen>
    ) => {
      state.isUnitsModalOpen = action.payload
    },
    onConfirmCancel: (
      state: IPortalState,
      action: PayloadAction<typeof initialState.confirmCancel>
    ) => {
      state.confirmCancel = action.payload
    },
  },
})

export const { actions, reducer } = slice

export type IPortal = {
  portal: IPortalState
}
